import { SubscriptionBoxProduct } from '../../../utils/subscriptionDetail/types';
import { QuantityUpdate } from '../../../hooks/use-product-cart';
import styles from '../../../assets/scss/SubscriptionDetail/NextDeliverySubscription/SubscriptionProduct.module.scss';

type Props = {
  box: SubscriptionBoxProduct;
  total: number;
  isChanged: boolean;
  quantities: Record<string, number>;
  changeQuantity: (updates: QuantityUpdate[]) => void;
  onClickBoxProductsSelect: (
    box: SubscriptionBoxProduct,
    quantities: Record<string, number>
  ) => void;
  onClickBoxSetContents: () => void;
};

export function BoxProduct({
  box,
  total,
  isChanged,
  quantities,
  changeQuantity,
  onClickBoxProductsSelect,
  onClickBoxSetContents,
}: Props) {
  const { parent, items } = box;

  const onClickSelectProducts = () => onClickBoxProductsSelect(box, quantities);

  const onClickDeleteProducts = () => {
    if (total === 0) return;

    const productQuantities: QuantityUpdate[] = [];
    for (const item of items) {
      productQuantities.push({ product: item, newQty: 0 });
    }
    changeQuantity(productQuantities);
  };

  return (
    <div className={styles.product}>
      {/* 画像、タイトル、割引率、値段 */}
      <StaticBoxProduct
        variantImage={parent.variantImage}
        title={parent.productTitle ?? parent.name}
        discountRate={parent.discountRate}
        minQuantity={parent.minQuantity}
        percent={parent.percent}
      />

      {/* セット内容を見る */}
      <p
        className={styles.productLink}
        onClick={onClickBoxSetContents}
      >
        セット内容を見る
      </p>

      {/* 選択肢、単品合計 */}
      <BoxProductTotals
        total={total}
        onClickSelectProducts={onClickSelectProducts}
        onClickDeleteProducts={onClickDeleteProducts}
      />

      {/* 変更文言 */}
      {isChanged && <p className={styles.changeMsg}>下の「変更内容を保存」を押してください</p>}

      {/* 特別文言 */}
      {parent.specialMsg && (
        <div
          className={styles.specialMsg}
          dangerouslySetInnerHTML={{ __html: parent.specialMsg }}
        />
      )}
    </div>
  );
}

type StaticBoxProductProps = {
  variantImage: string;
  title: string;
  discountRate: string;
  minQuantity: number;
  percent: number;
};

function StaticBoxProduct({
  variantImage,
  title,
  discountRate,
  minQuantity,
  percent,
}: StaticBoxProductProps) {
  return (
    <div className={styles.card}>
      <img
        className={styles.image}
        src={variantImage}
        alt=""
        loading="lazy"
      />
      <div className={styles.info}>
        <div
          className={styles.title}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <div className={styles.priceBox}>
          {discountRate ? (
            <div
              className={styles.percent}
              dangerouslySetInnerHTML={{ __html: discountRate }}
            />
          ) : (
            <p className={`${styles.percent} ${styles.red}`}>
              {minQuantity}個以上は{percent}%OFF
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

type BoxProductTotalsProps = {
  total: number;
  onClickSelectProducts: () => void;
  onClickDeleteProducts: () => void;
};

function BoxProductTotals({
  total,
  onClickSelectProducts,
  onClickDeleteProducts,
}: BoxProductTotalsProps) {
  const disabled = total === 0;

  return (
    <div className={styles.totals}>
      <button
        className={styles.selectBtn}
        onClick={onClickSelectProducts}
      >
        商品を選ぶ
      </button>

      {/* 削除ボタン */}
      <button
        className={styles.deleteBtn}
        onClick={onClickDeleteProducts}
        disabled={disabled}
      >
        削除
      </button>

      {/* 単品合計 */}
      <div className={styles.totalPrice}>
        <span className={styles.currency}>¥</span>
        <span className={styles.amount}>{total.toLocaleString()}</span>
      </div>
    </div>
  );
}
